import { createSelector } from 'reselect';
import { TextKey, RouteName } from '@mews-commander/enums';
import { getCurrentProfileId } from '@mews-commander/core';
import { hasCurrentEnterpriseServiceProviderMode } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { isCurrentProfilePlatformAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getSimpleSearchResult } from './getSimpleSearchResult';

export default createSelector(
    () => getCurrentProfileId(),
    isCurrentProfilePlatformAdmin,
    hasCurrentEnterpriseServiceProviderMode,
    (ownerId, isPlatformAdmin, hasServiceProviderMode) => {
        if (!isPlatformAdmin && !hasServiceProviderMode) {
            return [];
        }

        const params = { query: { OwnerId: ownerId } };

        return [
            getSimpleSearchResult({
                routeName: RouteName.ExportIndex,
                titleKey: TextKey.Archive,
            }),
            getSimpleSearchResult({
                routeName: RouteName.ExportScheduleIndex,
                titleKey: TextKey.Schedules,
                params,
            }),
            getSimpleSearchResult({
                routeName: RouteName.ExportTargetIndex,
                titleKey: TextKey.Targets,
                params,
            }),
        ];
    }
);
